<template>
<div class="content" v-if="parentItem">
    <section class="gen-form-container">
      <div class="edit-header">
        <div class="actions">
          <button class="btn btn-success" @click.prevent="save"><i class="fas fa-check"></i> Napravi</button>
        </div>
      </div>
      <form class="gf-row">
        <table>
          <thead>
            <tr>
              <th>Property</th>
              <th>Values</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="prop of parentItem.props">
              <td>{{ prop.type.title }}</td>
              <td>
                <label v-for="value of prop.type.values">
                  <input type="checkbox" v-model="variantsToCreate" :value="{value: value.uuid, label: value.value, propUuid: prop.type.uuid}" />
                  {{ value.value }}
                </label>
              </td>
            </tr>
          </tbody>
        </table>

      </form>
    </section>
</div>
</template>

<script>
import api from '@/Util/api';
import slug from '@/Util/slug';
import localizations from '@/Mixins/localizations';

export default {
  props: ["params", "index", "active"],
  data: ()=>({
    parentItem: null,
    perCategoryProps: [],
    variantsToCreate: [],
  }),
  methods: {
    async loadItem() {
      this.parentItem=(await api.get(this.params.type, this.$route.query.parent));
    },
    async save() {
      var propTypes=[];
      for(var variantToCreate of this.variantsToCreate) {
        var propType=propTypes.find(item=>item.uuid==variantToCreate.propUuid);
        if (!propType) {
          propType={uuid: variantToCreate.propUuid, values: []};
          propTypes.push(propType);
        }
        propType.values.push({
          uuid: variantToCreate.value,
          label: variantToCreate.label,
          type: variantToCreate.propUuid
        });
      }
      if (propTypes.length) {
        var varToCreate=[[]];
        for(var propType of propTypes) {
          var var2ToCreate=[];
          for(var varCr of varToCreate) {
            for(var propVal of propType.values) {
              var2ToCreate.push([...varCr, propVal]);
            }
          }
          varToCreate=var2ToCreate;
        }
      }
      for(var variant of varToCreate) {
        var product=api.create("Product");
        product.parent=this.parentItem.uuid;
        product.title=variant.map(varItem=>varItem.label).join(" ");
        product.props=this.parentItem.props.map(parentItem=>{
          var override=variant.find(varItem=>varItem.type==parentItem.type?.uuid);
          if (override) {
            return {
              type: override.type,
              typeValue: override.uuid,
              value: override.label,
            };
          } else {
            return {
              type: parentItem.type?.uuid,
              typeValue: parentItem.typeValue?.uuid,
              value: parentItem.value,
            }
          }
        });
        await product.save();
      }
    },
  },
  created() {
    this.loadItem();
  },
}
</script>
